"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import type * as React from "react";

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      // O site anterior era sempre claro. Manter claro como padrão preserva
      // essa identidade mesmo para quem usa o sistema em modo escuro; a
      // alternância continua disponível para o visitante.
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
